// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container_1PUnZ","hello":"Index_hello_9Bzlw","logo":"Index_logo_1aw-R","card":"Index_card_1sPih"};